import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faRuler, faCode, faRocket } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const Workflow = ({ content }) => {
  const { t } = useTranslation();
  
  return (
    <section id="workflow" className="py-20 bg-gray-50">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-16">{t('workflow.title')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-custom text-white flex items-center justify-center mx-auto mb-6">
              <FontAwesomeIcon icon={faComments} className="text-2xl" />
            </div>
            <h3 className="text-lg font-semibold mb-3">{t('workflow.discovery.title')}</h3>
            <p className="text-gray-600">{t('workflow.discovery.description')}</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-custom text-white flex items-center justify-center mx-auto mb-6">
              <FontAwesomeIcon icon={faRuler} className="text-2xl" />
            </div>
            <h3 className="text-lg font-semibold mb-3">{t('workflow.planning.title')}</h3>
            <p className="text-gray-600">{t('workflow.planning.description')}</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-custom text-white flex items-center justify-center mx-auto mb-6">
              <FontAwesomeIcon icon={faCode} className="text-2xl" />
            </div>
            <h3 className="text-lg font-semibold mb-3">{t('workflow.development.title')}</h3>
            <p className="text-gray-600">{t('workflow.development.description')}</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-custom text-white flex items-center justify-center mx-auto mb-6">
              <FontAwesomeIcon icon={faRocket} className="text-2xl" />
            </div>
            <h3 className="text-lg font-semibold mb-3">{t('workflow.launch.title')}</h3>
            <p className="text-gray-600">{t('workflow.launch.description')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Workflow;
